import {map, switchMap} from "rxjs";
const windowNameSpace = '__command_shared_service__'

const mySystem = 'Command'
//
export const sharedServicesMgr = window[windowNameSpace]
//
export function getService$(name) {
  return sharedServicesMgr.getService$(mySystem, name).pipe(map(x => x()))
}
export function getService(name) {
  return sharedServicesMgr.getService(mySystem, name)()
}
//
export const systemInfo = getService('System')
//
export const RouterWatcher$ = getService$('RouterWatcher')
//
export const sideBar$ = getService$('SideBar').pipe(switchMap(x => x))
//
export const spaService$ = getService$('SpaService')
//
export const userPermissionsConfig$ = getService$('userPermissionsConfig')
//
export let DSPUserPermissionsConfig = null;
systemInfo.isDispatch &&
userPermissionsConfig$.subscribe(x => {
  DSPUserPermissionsConfig = x;
})

export const globalImport = getService('GlobalImport')
//
export const dispatchCommandLike$ = getService$('DispatchCommandLike')

export const userService$ = getService$('userService')
//
export const DispatchComponents$ = getService$('DispatchComponents')
//
export const commonData = getService('CommonData')
//
export const DSPNotification$ = getService$('Notification')
//
export const registerGuid$ = getService$('RegisterGuid')
//
export const Voice$ = getService$('Voice')
//
export const OnBoarding$ = getService$('OnBoarding')

